import React from 'react';
import {generateAiAssistantText} from '../generateAiAssisntantText';

interface Props {
  value: string;
  setValue: (value: string) => void;
}

const TitleInput = React.memo(({value, setValue}: Props) => {
  return (
    <>
      <div className="AiAssitantTitleInput">
        <span className="TitleStar">*</span>
        <input
          value={value}
          onChange={e => setValue(e.target.value)}
          className="TitleInput"
          placeholder={generateAiAssistantText.titlePlaceholder}
          maxLength={50}
        />
      </div>
      <div className="TitleInputMaxCharacters">
        <span>{value.length}/50</span>
      </div>
    </>
  );
});

export default TitleInput;
